<template>
  <div id="app">
    <mp-nav></mp-nav>
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
import MpNav from '@/components/mp-nav'
export default {
  name: 'App',
  components: {
    MpNav
  }
}
</script>



// WEBPACK FOOTER //
// src/views/app.vue